

<div class="container-fluid main__head d-flex justify-content-center align-items-center position-relative">
  
  <div class="container h-100">
         <div class="row h-100 justify-content-center align-items-center">
        <form class="col-md-9">
            <div class="AppForm shadow-lg">
                <div class="row">
                    <div class="col-md-6">
                        <div class="AppFormRight position-relative d-flex justify-content-center flex-column align-items-center text-center p-5 text-white">
                          <h2 class="position-relative px-4 pb-3 mb-4">Welcome</h2>
                          <img style=" width: 11rem;
                       " src="https://punjab.gov.in/wp-content/themes/business-epic/assets/images/punjab-gov.svg" alt="">
                           
                            <h3 class="text-white heading pt-4">Punjab Building and Other Construction Workers Welfare Board</h3>
                        </div>
                    </div>
                    <div class="col-md-6 d-flex justify-content-center align-items-center glass_effect" *ngIf="isShow==true">
                      <div class="AppFormLeft" [formGroup]="loginfrm">

                          <h1 class="mb-4">Login</h1>
                          <div class="form-group position-relative mb-4">
                              <input type="text"   id="inputEmail"  formControlName="username" class="form-control border-top-0 border-right-0 border-left-0 rounded-0 shadow-none" id="username"
                                  placeholder="Username">
                                  <i class="fa fa-user-o mr-3"></i>
                          </div>
                          <div class="form-group position-relative mb-4">
                              <input type="password" id="inputPassword" formControlName="pass" class="form-control border-top-0 border-right-0 border-left-0 rounded-0 shadow-none" id="password"
                                  placeholder="Password">
                                  <i class="fa fa-key mr-3"></i>

                          </div>
                          <div class="row  mt-4 mb-4">
                              <div class="col-md-6">
                                  <!-- <div class="form-check">
                                      <input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
                                      <label class="form-check-label" for="defaultCheck1">
                                          Remember me
                                      </label>
                                  </div> -->
                              </div>
                              <div class="col-md-6 text-right">
                                  <a  [routerLink]="['/forgot']" routerLinkActive="router-link-active">Forgot Password?</a>
                              </div>
                          </div>
                          <button class="btn btn-success btn-block shadow border-0 py-2 text-uppercase " (click)="loginFun()">
                              Login
                          </button>
                          <p class="text-center mt-5">
                              Don't have an account?
                              <span>
                                <a  class="text-danger" target="_blank" href="https://connectuat.csccloud.in/account/authorize?response_type=code&client_id=04fdea06-de77-4947-d9c6-e13cb91dc177&redirect_uri=http://20.244.5.14:3000/csc/authorize&state=67234555" style="color:#fff"> Sign in with CSC</a>
                              </span>
                          </p>

                      </div>

                  </div>
                </div>
            </div>
  
        </form>
    </div>
  </div>
</div>

